<template>
	<div ref="slider" class="slider">
		<table class="label-table">
			<tr>
				<td v-for="(label, i) in labels" :key="`label-${i}`" class="label" :style="{ width: label.width }">
					<span>
						{{ label.text }}
					</span>
				</td>
			</tr>
		</table>

		<div class="line">
			<div v-for="(tick, i) in ticks" :key="`tick-${i}`" class="tick" :style="{ left: tick.left }">
				<div  v-if="!hideNumbers">
					<div class="tick-text" v-if="(tick.hover && tick.hover != '')" v-tippy :content="tick.hover" >{{ tick.number }}</div>
					<div class="tick-text" v-else >{{ tick.number }}</div>
				</div>
			</div>
			<div class="number-line-end"></div>
			<div v-if="value != null" class="dot" :class="getColorClass()" :style="{ left: markOffset }"></div>
		</div>
	</div>
	<!-- <table>
		<tbody>
			<tr class="pt-reduce pb-none">
				<td colspan="11" class="_600">Progress Advancement</td>
			</tr>
			<tr class="number-line pt-none" :class="getColor()">
				<td>
					<div class="number-line-piece"><div v-if="score == 0" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 1" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 2" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 3" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 4" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 5" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 6" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 7" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 8" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 9" class="number-line-mark"></div></div>
				</td>
				<td>
					<div class="number-line-piece"><div v-if="score == 10" class="number-line-mark"></div></div>
					<div class="number-line-end"></div>
				</td>
			</tr>
			<tr class="b-t pt-reduce pb-reduce">
				<th class="b-l">Not Covered</th>
				<th class="b-l" colspan="3">Lacking detail</th>
				<th class="b-l" colspan="3">Sufficiently covered in some parts but not others</th>
				<th class="b-l" colspan="3">Covered with sufficient detail</th>
				<th class="b-l b-r">Covered with exemplary detail</th>
			</tr>
			<tr class="b-t pb-reduce" style="height: 30px;">
				<td class="b-l" style="width: 20%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="0" v-model="score" />
				</td>
				<td class="b-l" style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="1" v-model="score" />
				</td>
				<td style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="2" v-model="score" />
				</td>
				<td style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="3" v-model="score" />
				</td>
				<td class="b-l" style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="4" v-model="score" />
				</td>
				<td style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="5" v-model="score" />
				</td>
				<td style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="6" v-model="score" />
				</td>
				<td class="b-l" style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="7" v-model="score" />
				</td>
				<td style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="8" v-model="score" />
				</td>
				<td style="width: 6.67%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="9" v-model="score" />
				</td>
				<td class="b-l b-r" style="width: 20%;">
					<input class="" type="radio" :name="`${groupName}-score`" :value="10" v-model="score" />
				</td>
			</tr>
			<tr class="b-b pt-reduce">
				<td class="b-l"></td>
				<td class="b-l">Low</td>
				<td>Mid</td>
				<td>High</td>
				<td class="b-l">Low</td>
				<td>Mid</td>
				<td>High</td>
				<td class="b-l">Low</td>
				<td>Mid</td>
				<td>High</td>
				<td class="b-l b-r"></td>
			</tr>
		</tbody>
	</table> -->
</template>

<script>
export default {
	name: "HundredSlider",

	props: ["value", "color", "marks", "hideNumbers"],

	data() {
		return {
			ticks: [],
			labels: [],
			max: 100,
		};
	},

	mounted() {
		this.$refs.slider.addEventListener("mousedown", this.startSlide);
		document.addEventListener("mouseup", this.endSlide);
		this.constructMarks();
	},

	destroyed() {
		document.removeEventListener("mouseup", this.endSlide);
	},

	computed: {
		markOffset() {
			return `calc(${this.value * 100 / this.max}% - 8px)`;
		},
	},

	watch: {
		marks() {
			this.constructMarks();
		},
	},

	methods: {
		getMax() {
			let max = 0;
			for (let i = 0; i < this.marks.length; i++) {
				let mark = this.marks[i];
				if (typeof mark == "number") {
					if (mark > max) {
						max = mark;
					}
				}
			}
			return max;
		},
		getColorClass() {
			return { [`si-${this.color}`]: true };
		},

		startSlide(event) {
			this.doSlide(event.offsetX);
			this.$refs.slider.addEventListener("mousemove", this.doSlideEvent);
		},

		endSlide() {
			this.$refs.slider.removeEventListener("mousemove", this.doSlideEvent);
		},

		doSlideEvent(event) {
			this.doSlide(event.offsetX);
		},

		doSlide(x) {
			let width = this.$refs.slider.clientWidth - 6;

			//constrain values to range of slider
			if (x < 0) {
				x = 0
			}
			if (x > width) {
				x = width
			}

			let percent = Math.round((this.max * x) / width);
			this.$emit("input", percent);
		},

		constructMarks() {
			this.max = this.getMax();
			let pos = 0;
			this.ticks = [];
			this.labels = [];
			for (let i = 0; i < this.marks.length; i++) {
				let mark = this.marks[i];
				if (typeof mark == "number") {
                    if (this.ticks.filter(t =>
                        t.number == mark
                    ).length == 0) {
                        this.ticks.push({
                            number: mark,
                            left: `calc(${mark * 100 / this.max}% - 1.5px)`,
                        });
                    }
					pos = mark * 100 / this.max;
				} else if (typeof mark == "string") {
					let next = this.marks[i + 1];
					if (!(next && typeof next == "number")) {
						continue;
					}

					this.labels.push({
						text: mark,
						left: `${pos}%`,
						width: `${next * 100 / this.max - pos}%`,
					});
				} else {
                    let prev = this.marks[i - 1];
					let next = this.marks[i + 1];
                    if (typeof prev == "number") {
                        this.ticks[this.ticks.length - 1].hover = mark.description;
                    }
					if (!(next && typeof next == "number")) {
						continue;
					}

                    if (mark.label != "") {
                        this.labels.push({
                            text: mark.label,
                            left: `${pos}%`,
                            width: `${next * 100 / this.max - pos}%`,
                        });
                    }
				}
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
	padding-top: 13.5px;
	padding-right: 8px;
	padding-bottom: 50px;
	cursor: pointer;
}

.line {
	position: relative;
	border-bottom: 3px solid rgb(200, 200, 200);
}

.tick {
	position: absolute;
	top: -13.5px;
	height: 30px;
	border-left: 3px solid rgb(200, 200, 200);
}

.tick-text {
	position: absolute;
	top: 34px;
	width: 50px;
	left: -26px;
	text-align: center;
	font-size: 18px;
}

.label-table {
	width: 100%;
	table-layout: fixed;
}

.label {
	user-select: none;
	-webkit-user-select: none;
	font-size: 18px;
	font-weight: 600;
	padding: 0.5rem;
	text-align: center;
	pointer-events: none;
}

.dot {
	position: absolute;
	top: -7px;
	border-radius: 50%;
	width: 16px;
	height: 16px;
	background-color: rgb(200, 200, 200);
	pointer-events: none;
}

.number-line-end {
	position: absolute;
	right: -13px;
	top: -7px;
	height: 17px;
	width: 12px;
	border-left: 12px solid rgb(200, 200, 200);
	border-top: 8px solid transparent;
	border-bottom: 8px solid transparent;
	pointer-events: none;
}
</style>
